<mat-card appearance="outlined" class="deprecated-banner" [class]="'palette-' + type()">
    <mat-card-content>
        <div class="message-wrapper">
            <mat-icon [color]="type()">{{ icon() }}</mat-icon>
            <span class="message-text" [innerHTML]="message()"></span>
        </div>
    </mat-card-content>
</mat-card>